export class DialogModelConfirmReason {
    constructor(
      public message: any
    ) {}
  }
  